<div class="py-4 container-fluid study-period-page">
    <h4 class="mb-4 study-period-title">การตั้งค่า - ช่วงเวลาการศึกษา</h4>

    <div class="study-period-card">
        <div class="study-period-card-body">

            <div class="study-period-toolbar" [formGroup]="form">
                <div class="study-period-filters">
                    <div class="study-period-filter">
                        <app-select label="เทอมการศึกษา" formControlName="name" [options]="['1', '2', '3']"
                            [searchable]="false" [clearable]="true" inputClass="study-period-select" classes="mb-0">
                        </app-select>
                    </div>
                    <div class="study-period-filter">
                        <app-select label="ปีการศึกษา" formControlName="year" [options]="yearOptions"
                            [searchable]="false" [clearable]="true" inputClass="study-period-select" classes="mb-0">
                        </app-select>
                    </div>
                </div>

                <button type="button" class="btn study-period-add-button" (click)="onAddAcademicTerm()">
                    <img src="assets/media/icons/svg/add-item.svg" class="study-period-toolbar-icon" alt="" aria-hidden="true" />
                    <span>เพิ่มรายการใหม่</span>
                </button>
            </div>

            <ng-template #rowIndexTemplate let-row="row" let-rowIndex="rowIndex">
                {{ row.sequence ?? academicTerms().offset + rowIndex + 1 }}
            </ng-template>

            <ng-template #tableCellAction let-row="row">
                <div class="study-period-actions">
                    @if (row.canEdit) {
                        <button type="button" class="btn study-period-action-button" (click)="onEditAcademicTerm(row)"
                            aria-label="แก้ไขช่วงเวลาการศึกษา">
                            <img
                                src="assets/media/icons/svg/pencxil.svg"
                                class="study-period-action-icon"
                                alt=""
                                aria-hidden="true"
                            />
                        </button>
                    }

                    @if (row.canDelete) {
                        <button type="button" class="btn study-period-action-button"
                            (click)="onDeleteAcademicTerm(row)" aria-label="ลบช่วงเวลาการศึกษา">
                            <img
                                src="assets/media/icons/svg/trush.svg"
                                class="study-period-action-icon"
                                alt=""
                                aria-hidden="true"
                            />
                        </button>
                    }
                </div>
            </ng-template>
            <app-datatable [datasource]="academicTerms()" [columns]="columns" [isLoading]="tableLoading()"
                [limit]="10" [showOrder]="false" (sortChange)="onSortChange($event)"></app-datatable>

            <app-table-pagination
                [page]="academicTerms().page"
                [limit]="academicTerms().limit"
                [total]="academicTerms().total"
                [totalPage]="academicTerms().total_page"
                [offset]="academicTerms().offset"
                [dataLength]="academicTerms().data.length"
                [pageSizeOptions]="pageSizeOptions"
                ariaLabel="Study period pagination"
                (pageChange)="onPageChange($event)"
                (limitChange)="onLimitChange($event)"
            ></app-table-pagination>
 
        </div>
    </div>

</div>
<app-form-add-academic-term
    (saved)="onAcademicTermSaved($event)"
    (saveFailed)="onAcademicTermSaveFailed($event)"
    (synced)="onAcademicTermSynced()"
    (syncFailed)="onAcademicTermSyncFailed($event)"
    (previewFailed)="onAcademicTermPreviewFailed($event)"
>
</app-form-add-academic-term>
<app-confirm-dialog
    #deleteAcademicTermConfirmDialog
    modalId="deleteAcademicTermConfirm"
    title="ยืนยันการลบรายการ"
    message="คุณต้องการลบรายการนี้ใช่หรือไม่ ?"
    cancelText="ยกเลิก"
    confirmText="ยืนยัน"
    [isProcessing]="isDeleting"
    (confirmed)="onConfirmDeleteAcademicTerm()"
    (cancelled)="onCancelDeleteAcademicTerm()"
></app-confirm-dialog>
<app-confirm-dialog
    #deleteAcademicTermSuccessDialog
    modalId="deleteAcademicTermSuccess"
    icon="success"
    title="ลบรายการสำเร็จ"
    message="ลบข้อมูลช่วงเวลาการศึกษาเรียบร้อยแล้ว"
    confirmText="ปิด"
    [showCancelButton]="false"
    (confirmed)="deleteAcademicTermSuccessDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
    #deleteAcademicTermErrorDialog
    modalId="deleteAcademicTermError"
    icon="error"
    title="ไม่สามารถลบรายการได้"
    [message]="deleteAcademicTermErrorMessage"
    confirmText="ปิด"
    [showCancelButton]="false"
    (confirmed)="deleteAcademicTermErrorDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
    #createAcademicTermSuccessDialog
    modalId="createAcademicTermSuccess"
    icon="success"
    title="เพิ่มรายการสำเร็จ"
    message="เพิ่มข้อมูลช่วงเวลาการศึกษาเรียบร้อยแล้ว"
    confirmText="ปิด"
    [showCancelButton]="false"
    (confirmed)="createAcademicTermSuccessDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
    #createAcademicTermErrorDialog
    modalId="createAcademicTermError"
    icon="error"
    title="ไม่สามารถเพิ่มรายการได้"
    [message]="createAcademicTermErrorMessage"
    confirmText="ปิด"
    [showCancelButton]="false"
    (confirmed)="createAcademicTermErrorDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
    #editAcademicTermSuccessDialog
    modalId="editAcademicTermSuccess"
    icon="success"
    title="แก้ไขรายการสำเร็จ"
    message="แก้ไขข้อมูลช่วงเวลาการศึกษาเรียบร้อยแล้ว"
    confirmText="ปิด"
    [showCancelButton]="false"
    (confirmed)="editAcademicTermSuccessDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
    #editAcademicTermErrorDialog
    modalId="editAcademicTermError"
    icon="error"
    title="ไม่สามารถแก้ไขรายการได้"
    [message]="editAcademicTermErrorMessage"
    confirmText="ปิด"
    [showCancelButton]="false"
    (confirmed)="editAcademicTermErrorDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
    #syncAcademicTermSuccessDialog
    modalId="syncAcademicTermSuccess"
    icon="success"
    title="Sync ข้อมูลสำเร็จ"
    message="Sync ข้อมูลรายวิชาจาก REG เรียบร้อยแล้ว"
    confirmText="ปิด"
    [showCancelButton]="false"
    (confirmed)="syncAcademicTermSuccessDialog.close()"
></app-confirm-dialog>
<app-confirm-dialog
    #syncAcademicTermErrorDialog
    modalId="syncAcademicTermError"
    icon="error"
    title="ไม่สามารถ Sync ข้อมูลได้"
    [message]="syncAcademicTermErrorMessage"
    confirmText="ปิด"
    [showCancelButton]="false"
    (confirmed)="syncAcademicTermErrorDialog.close()"
></app-confirm-dialog>
